import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {FirebaseError} from 'firebase';
import {AuthApi} from '@/api/auth.api';
import {take} from 'rxjs/operators';
import {SignInCredentials} from '@/models/user.model';
import {AuthenticatedModel} from '@/models/authenticated.model';
import store from '@/store';
import {HttpError} from '@/models/http.error';
import {featureKey as userFeatureKey} from './user.store';

export const featureKey = 'auth';

// @ts-ignore
if (store.state.auth) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class AuthStoreModule extends VuexModule {
  private _credentials: AuthenticatedModel | null = null;
  private _authenticationErrors: HttpError | FirebaseError | null = null;

  @Mutation
  authenticationSuccess(data: AuthenticatedModel) {
    this._credentials = data;
    store.dispatch(`${userFeatureKey}/fetchUser`);
  }

  @Mutation
  authenticationFailed(error: HttpError) {
    this._authenticationErrors = error
  }

  @Mutation
  logoutSuccess() {
    localStorage.removeItem('credentials');
    this._credentials = null;
    this._authenticationErrors = null;
    store.commit(`${userFeatureKey}/setUser`, null)
  }

  @Action({commit: 'authenticationSuccess', rawError: true})
  async makeLogin(credentials: SignInCredentials): Promise<AuthenticatedModel> {
    return await (new AuthApi()
      .signIn(credentials))
      .pipe(take(1))
      .toPromise()
  }

  @Action({commit: 'logoutSuccess', rawError: true})
  logout() {
    return;
  }

  @Action
  alreadyLoggedIn() {
    const saved = localStorage.getItem('credentials');
    if (!saved) {
      return
    }
    const credentials = JSON.parse(saved);
    if (credentials) {
      return this.context.commit('authenticationSuccess', credentials);
    }
  }

  get credentials(): AuthenticatedModel | null {
    return this._credentials;
  }

  get authenticationErrors(): HttpError | FirebaseError | null {
    return this._authenticationErrors || null;
  }

  get isAuthenticated(): boolean {
    return !!this._credentials
  }
}
